var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusVpsIcon = function SvgPlusVpsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#E20000"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.167 9.167v-5h1.666v5h5v1.666h-5v5H9.166v-5h-5V9.166z"
  })));
};
export default SvgPlusVpsIcon;